import { render, staticRenderFns } from "./AdminApplications.vue?vue&type=template&id=1665ded9"
import script from "./AdminApplications.vue?vue&type=script&lang=js"
export * from "./AdminApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1665ded9')) {
      api.createRecord('1665ded9', component.options)
    } else {
      api.reload('1665ded9', component.options)
    }
    module.hot.accept("./AdminApplications.vue?vue&type=template&id=1665ded9", function () {
      api.rerender('1665ded9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminApplications.vue"
export default component.exports